export class DbAgentGrpcSettingsInfos {
  port: number | null = 0;
  timeoutSeconds: number | null = 0;
  user: string | null = null;
  password: string | null = null;
  callsCount: number | null = 0;
  infoUpdateDelayMs: number | null = 0;

  constructor(init?: Partial<DbAgentGrpcSettingsInfos>) {
    Object.assign(this, init);
  }
}
